const homeBreadcrumb = {
  heading: 'Domov',
  onClick: () => {
    window.parent.postMessage({
      type: 'iframe-to-parent-external-route',
      route: '/',
    }, '*');
  },
};

export default homeBreadcrumb;
